/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useContext, useEffect, useRef, useState } from "react";
import { Alert, Button, Spin, Tabs } from "antd";
import MapPropsContext from "../MapPropsContext";
import loadJS from "load-js";
import Axios from "axios";
import useDebounce from "../../../utils/hooks/useDebounce";
import usePortal from "react-useportal";
import { getApiHost } from "../../../utils";
import ModalFixed from "../widgets/ModalFixed";
import ChartPane from "./ChartPane";
import { TI_CHART_BUTTON } from "../../../Constants";
import { StyledButton } from "../../../styled-components/Button";

function RMateChartStatsAnalysis({ disabled }) {
  const { chartAjaxParams, chartDivVisible, setChartDivVisible } =
    useContext(MapPropsContext);

  const chartProfile = window.CHART_PROFILE || "dev";
  const [isInit, setIsInit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState();
  const [parsedObject, setParsedObject] = useState({});
  const { sidoCode, searchYear, searchYear_bf, chkString } = chartAjaxParams;
  const [prevParams, setPrevParmas] = useState({});

  useEffect(() => {
    let chartUrlList = [
      `/js/chart/LicenseKey/${chartProfile}/rMateChartH5License.js`,
      "/js/chart/rMateIntegrationH5.js",
    ];
    loadJS(chartUrlList).then(() => {
      setIsInit(true);
    });
  }, []);

  useDebounce(
    () => {
      if (isInit) {
        const url = getApiHost() + "/rwdinfolabstats/getYearByClsBySmCmpr.json";

        const params = {
          sidoCode,
          searchYear,
          searchYear_bf,
          chkString,
        };

        if (JSON.stringify(params) !== JSON.stringify(prevParams)) {
          setPrevParmas(params);
          setIsLoading(true);
          setError(null);
          setParsedObject({}); // 초기화

          Axios.get(url, { params })
            .then(({ data }) => {
              const { itemSm } = data; // 외 itemLagend
              const chart1Data = dataSettingByCls(itemSm, searchYear);
              setParsedObject({ chart1Data });
            })
            .catch((e) => {
              console.error(e);
              setError(e);
            })
            .finally(() => {
              setIsLoading(false);
            });
        }
      }
    },
    1000,
    [isInit, chartAjaxParams, setIsLoading, setParsedObject]
  );

  const { chart1Data } = parsedObject;

  const { Portal } = usePortal({
    bindTo:
      document && document.getElementsByClassName("toolbar-show-chart")[1],
  });
  const checkRangeOK = (searchStart, searchEnd) => {
    const rangeFlag = getIs24Month(searchStart, searchEnd);
    if (rangeFlag === false) {
      alert(
        "기준년월과 비교년월의 차이가 24개월을 초과할 경우 차트보기를 지원하지 않습니다."
      );
      return false;
    }
    return true;
  };

  const openChartModalButton = useRef();

  useEffect(() => {
    setChartDivVisible(!disabled);
  }, [disabled]);

  // 화면 초기 진입 시 차트 비활성화하기 (이벤트를 한개라도 줄여서 처음 렌더링 속도 개선) - 20.02.26(수)검수 테스트 결과 요청사항
  useEffect(() => {
    setChartDivVisible(false);
  }, []);

  const closeButtonRef = useRef(null);

  return (
    <>
      <Portal>
        <StyledButton
          disabled={disabled}
          onClick={() => {
            setTimeout(() => {
              if (closeButtonRef.current) {
                closeButtonRef.current.focus();
              }
            }, 500);

            if (checkRangeOK(searchYear, searchYear_bf)) {
              return setChartDivVisible(!chartDivVisible);
            } else {
              alert(
                "기준년월과 비교년월의 차이가 24개월을 초과할 경우 차트보기를 지원하지 않습니다."
              );
              return false;
            }
          }}
          isActive={chartDivVisible}
          tabIndex={TI_CHART_BUTTON}
          ref={openChartModalButton}
        >
          차트 보기
        </StyledButton>
      </Portal>
      <ModalFixed
        visible={chartDivVisible}
        setVisible={setChartDivVisible}
        closeButtonRef={closeButtonRef}
        openChartModalButtonRef={openChartModalButton}
      >
        {/* <Tabs defaultActiveKey={"1"} type={"card"}>
          <Tabs.TabPane tab="연도별 지역별 무선국 수 연간 비교" key={"1"}> */}
        {isLoading && (
          <div
            style={{
              position: "absolute",
              zIndex: 6,
              height: "400px",
              width: "795px",
              backgroundColor: "white",
            }}
          >
            <Spin size={"large"}>
              <Alert
                message="차트 로딩 중"
                description="선택한 무선국의 정보를 불러오는 중입니다.."
                type="info"
                showIcon
                style={{ height: "400px" }}
              />
            </Spin>
          </div>
        )}
        {error && <Alert type={"error"} message={"오류가 발생했습니다."} />}
        <ChartPane
          data={chart1Data}
          processor={() => chart1Data}
          layoutProcessor={() => setChartLayout(searchYear, searchYear_bf)}
          style={{ height: 400 }}
        />
        {/* </Tabs.TabPane>
        </Tabs> */}
      </ModalFixed>
    </>
  );
}

/// 차트 정의시 필요한 펑션
const getIs24Month = (searchStart, searchEnd) => {
  if (searchStart && searchEnd) {
    const intSearchStart = parseInt(searchStart);
    const intSearchEnd = parseInt(searchEnd);

    if (intSearchStart > intSearchEnd) {
      return false;
    }

    const monthRange =
      parseInt(searchEnd.substring(4, 2)) -
      parseInt(searchStart.substring(4, 2));
    const yearMonthRange =
      (parseInt(searchEnd.substring(0, 4)) -
        parseInt(searchStart.substring(0, 4))) *
        12 +
      monthRange;
    if (yearMonthRange <= 24) {
      return true;
    }
    return false;
  }
};

function insertComma(n) {
  let reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n)) n = n.replace(reg, `$1,$2`);
  return n;
}

// 데이터 수정 - 무선국별
const dataSettingByCls = (dataList, searchYear) => {
  let _staData_cmpr;
  // itemSm
  if (dataList) {
    let tmpChartRow = {};
    let NOW_LEG_DNR_CD = "";

    let tmpAry = [];

    for (let i = 0; i < dataList.length; ++i) {
      let item = dataList[i];
      /// grid용 생성
      let tmpData = {};
      tmpData.LEG_DNR_CD = item.LEG_DNR_CD;
      tmpData.LEG_DNR_NM = item.LEG_DNR_NM;
      tmpData.CMPR_YEAR = item.CMPR_YEAR;
      tmpData.CNT_SUM = item.CNT_SUM;
      tmpData.CNT_SUM_str = insertComma(item.CNT_SUM);

      tmpData.CNT_32 = item.CNT_32;
      tmpData.CNT_32_str = insertComma(item.CNT_32);
      tmpData.CNT_94 = item.CNT_94;
      tmpData.CNT_94_str = insertComma(item.CNT_94);
      tmpData.CNT_44 = item.CNT_44;
      tmpData.CNT_44_str = insertComma(item.CNT_44);
      tmpData.CNT_85 = item.CNT_85;
      tmpData.CNT_85_str = insertComma(item.CNT_85);
      tmpData.CNT_49 = item.CNT_49;
      tmpData.CNT_49_str = insertComma(item.CNT_49);
      tmpData.CNT_92 = item.CNT_92;
      tmpData.CNT_92_str = insertComma(item.CNT_92);
      tmpData.CNT_42 = item.CNT_42;
      tmpData.CNT_42_str = insertComma(item.CNT_42);
      tmpData.CNT_41 = item.CNT_41;
      tmpData.CNT_41_str = insertComma(item.CNT_41);
      tmpData.CNT_21 = item.CNT_21;
      tmpData.CNT_21_str = insertComma(item.CNT_21);
      tmpData.CNT_CMFL = item.CNT_CMFL;
      tmpData.CNT_CMFL_str = insertComma(item.CNT_CMFL);
      tmpData.CNT_OTHER = item.CNT_OTHER;
      tmpData.CNT_OTHER_str = insertComma(item.CNT_OTHER);

      // chart용 생성
      if (i === 0) {
        tmpChartRow = {};
        NOW_LEG_DNR_CD = item.LEG_DNR_CD;
      }

      if (NOW_LEG_DNR_CD !== item.LEG_DNR_CD) {
        tmpAry.push(tmpChartRow);
        tmpChartRow = {};
        NOW_LEG_DNR_CD = item.LEG_DNR_CD;
      }

      tmpChartRow.LEG_DNR_CD = item.LEG_DNR_CD;
      tmpChartRow.LEG_DNR_NM = item.LEG_DNR_NM;
      //tmpChartRow.CMPR_YEAR = item.CMPR_YEAR;

      //if(item.CMPR_YEAR == $("#cmd_year_chart").find("option:selected").val()){
      if (item.CMPR_YEAR === searchYear) {
        tmpChartRow.CNT_SUM = item.CNT_SUM;
        tmpChartRow.CNT_SUM_str = insertComma(item.CNT_SUM);

        tmpChartRow.CNT_32 = item.CNT_32;
        tmpChartRow.CNT_32_str = insertComma(item.CNT_32);
        tmpChartRow.CNT_94 = item.CNT_94;
        tmpChartRow.CNT_94_str = insertComma(item.CNT_94);
        tmpChartRow.CNT_44 = item.CNT_44;
        tmpChartRow.CNT_44_str = insertComma(item.CNT_44);
        tmpChartRow.CNT_85 = item.CNT_85;
        tmpChartRow.CNT_85_str = insertComma(item.CNT_85);
        tmpChartRow.CNT_49 = item.CNT_49;
        tmpChartRow.CNT_49_str = insertComma(item.CNT_49);
        tmpChartRow.CNT_92 = item.CNT_92;
        tmpChartRow.CNT_92_str = insertComma(item.CNT_92);
        tmpChartRow.CNT_42 = item.CNT_42;
        tmpChartRow.CNT_42_str = insertComma(item.CNT_42);
        tmpChartRow.CNT_41 = item.CNT_41;
        tmpChartRow.CNT_41_str = insertComma(item.CNT_41);
        tmpChartRow.CNT_21 = item.CNT_21;
        tmpChartRow.CNT_21_str = insertComma(item.CNT_21);
        tmpChartRow.CNT_CMFL = item.CNT_CMFL;
        tmpChartRow.CNT_CMFL_str = insertComma(item.CNT_CMFL);
        tmpChartRow.CNT_OTHER = item.CNT_OTHER;
        tmpChartRow.CNT_OTHER_str = insertComma(item.CNT_OTHER);
      } else {
        tmpChartRow.CNT_SUM_bf = item.CNT_SUM;
        tmpChartRow.CNT_SUM_str_bf = insertComma(item.CNT_SUM);

        tmpChartRow.CNT_32_bf = item.CNT_32;
        tmpChartRow.CNT_32_str_bf = insertComma(item.CNT_32);
        tmpChartRow.CNT_94_bf = item.CNT_94;
        tmpChartRow.CNT_94_str_bf = insertComma(item.CNT_94);
        tmpChartRow.CNT_44_bf = item.CNT_44;
        tmpChartRow.CNT_44_str_bf = insertComma(item.CNT_44);
        tmpChartRow.CNT_85_bf = item.CNT_85;
        tmpChartRow.CNT_85_str_bf = insertComma(item.CNT_85);
        tmpChartRow.CNT_49_bf = item.CNT_49;
        tmpChartRow.CNT_49_str_bf = insertComma(item.CNT_49);
        tmpChartRow.CNT_92_bf = item.CNT_92;
        tmpChartRow.CNT_92_str_bf = insertComma(item.CNT_92);
        tmpChartRow.CNT_42_bf = item.CNT_42;
        tmpChartRow.CNT_42_str_bf = insertComma(item.CNT_42);
        tmpChartRow.CNT_41_bf = item.CNT_41;
        tmpChartRow.CNT_41_str_bf = insertComma(item.CNT_41);
        tmpChartRow.CNT_21_bf = item.CNT_21;
        tmpChartRow.CNT_21_str_bf = insertComma(item.CNT_21);
        tmpChartRow.CNT_CMFL_bf = item.CNT_CMFL;
        tmpChartRow.CNT_CMFL_str_bf = insertComma(item.CNT_CMFL);
        tmpChartRow.CNT_OTHER_bf = item.CNT_OTHER;
        tmpChartRow.CNT_OTHER_str_bf = insertComma(item.CNT_OTHER);
      }
    }

    if (dataList.length > 0) {
      tmpAry.push(tmpChartRow);
    }

    tmpAry.sort(function (a, b) {
      return b.CNT_SUM - a.CNT_SUM;
    });

    if (tmpAry != null && tmpAry.length > 0) _staData_cmpr = tmpAry;
    return _staData_cmpr;
  }
};
// 서비스별 무선국 수
const setChartLayout = (searchYear, searchYear_bf) => {
  let layoutStr_cmpr =
    '<rMateChart backgroundColor="#FFFFFF"  borderStyle="none">' +
    "<Options>" +
    '<Caption text="연도별 지역별 무선국 수 연간 비교" fontSize="19"/>' +
    //+'<Caption text="연도별 지역별 무선국 수 연간 비교  &lt;a href=javascript:cartDownload(\'chart1\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart1\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt;" fontSize="19"/>'
    '<SubCaption text="" textAlign="right" />' +
    '<Legend defaultMouseOverAction="false" useVisibleCheck="true" fontSize="15" position="bottom" hAlign="center" />' +
    "</Options>" +
    '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>' +
    '<Column3DChart showDataTips="true">' +
    "<verticalAxis>" +
    '<LinearAxis id="vAxis" title="무선국 수" formatter="{numfmt}" labelJsFunction="labelFuncNum"/>' +
    "</verticalAxis>" +
    "<verticalAxisRenderers>" +
    '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">' +
    "<axisStroke>" +
    '<Stroke weight="10" color="#f4f4f4"/>' +
    "</axisStroke>" +
    "<tickStroke>" +
    '<Stroke weight="1" color="#d2d2d2" alpha="1"/>' +
    "</tickStroke>" +
    "<minorTickStroke>" +
    '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>' +
    "</minorTickStroke>" +
    "</Axis3DRenderer>" +
    "</verticalAxisRenderers>" +
    "<horizontalAxis>" +
    '<CategoryAxis id="hAxis" title="지역명" categoryField="LEG_DNR_NM" labelJsFunction="labelFunc"/>' +
    "</horizontalAxis>" +
    "<horizontalAxisRenderers>" +
    '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" labelRotation="45" tickLength="10" minorTickLength="0" tickPlacement="outside" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">' +
    "<axisStroke>" +
    '<Stroke weight="10" color="#f4f4f4"/>' +
    "</axisStroke>" +
    "<tickStroke>" +
    '<Stroke weight="1" color="#d2d2d2" alpha="1"/>' +
    "</tickStroke>" +
    "<minorTickStroke>" +
    '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>' +
    "</minorTickStroke>" +
    "</Axis3DRenderer>" +
    "</horizontalAxisRenderers>" +
    "<series>";
  layoutStr_cmpr +=
    '<Column3DSet type="stacked" showTotalLabel="false" totalLabelJsFunction="totalFunc" color="#666" labelYOffset="-5">' +
    "<series>";

  let yearData =
    searchYear.substr(0, 4) + "년" + searchYear.substr(4, 2) + "월";

  layoutStr_cmpr +=
    '<Column3DSeries labelPosition="inside" showValueLabels="[]" yField="CNT_SUM" displayName="' +
    yearData +
    '">' +
    "<showDataEffect>" +
    "<SeriesInterpolate/>" +
    "</showDataEffect>" +
    "</Column3DSeries>";

  layoutStr_cmpr += "</series>" + "</Column3DSet>";

  layoutStr_cmpr +=
    '<Column3DSet type="stacked" showTotalLabel="false" totalLabelJsFunction="totalFunc" color="#666" labelYOffset="-1" labelXOffset="5">' +
    "<series>";

  let yearData_bf =
    searchYear_bf.substr(0, 4) + "년" + searchYear_bf.substr(4, 2) + "월";

  layoutStr_cmpr +=
    '<Column3DSeries labelPosition="inside" showValueLabels="[]" yField="CNT_SUM_bf" displayName="' +
    yearData_bf +
    '">' +
    "<showDataEffect>" +
    "<SeriesInterpolate/>" +
    "</showDataEffect>" +
    "</Column3DSeries>";

  layoutStr_cmpr += "</series>" + "</Column3DSet>";

  layoutStr_cmpr +=
    "</series>" +
    "</Column3DChart>" +
    "<Style>" +
    ".seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}" +
    ".title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}" +
    "</Style>" +
    "</rMateChart>";
  return layoutStr_cmpr;
};
// 년월간 서비스별 무선국 수 변동

export default RMateChartStatsAnalysis;
